import { schema } from 'normalizr';

const OpportunitySchema = {
	OPPORTUNITIES: new schema.Array(new schema.Entity('opportunities', {}, { idAttribute: 'providerAtSendingFacility' }))
};

export default OpportunitySchema;
